import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import FormCard from '../forms/FormCard';
import Form from '../forms/Form';
import { renderZemesLietojumsTable } from './DzeramaUdensSatecesBaseinsVisparigaisRaksturojums';

const getBaseinsSnapshotFormFieldCfgs = () => [
    { name: 'baseina_kods', label: 'Sateces baseina kods', editable: false },
    { name: 'uas_nosaukums', label: 'Ūdensapgādes sistēmas nosaukums', editable: false },
    { name: 'uas_operators', label: 'Operators', editable: false },
    { name: 'uas_atlaujas_nr', label: 'Atļaujas Nr.', editable: false },
    {
        name: 'platiba', label: 'Sateces baseina platība, ha', editable: false,
        renderer: (val) => val ? `${val} ha` : '-'
    },
    { name: 'urbumi_atradnes_nosaukums', label: 'Piederība pazemes ūdeņu atradnei', editable: false },
    {
        name: 'urbumi_snapshot', label: 'Ūdens ieguves vietas DB nr.', editable: false,
        renderer: (urbumi) => urbumi && urbumi.length > 0 ? urbumi.map(u => u.urbumi_id).join(', ') : '-'
    },
    { name: 'kategorija', label: 'Ūdensapgādes sistēmas kategorija, m³/d', editable: false },
    { name: 'pazemes_udensobjekts', label: 'Pazemes ūdensobjekts', editable: false },
    { name: 'admin_teritorija', label: 'Administratīvā teritorija', editable: false },
    { name: 'nesejslana_tips', label: 'Ūdens nesējslāņa tips', editable: false },
    { name: 'nesejslana_horizonta_indekss', label: 'Ūdens nesējslānis', editable: false },
    { name: 'aizsargatiba', label: 'Aizsargātības pakāpe', editable: false },
    { name: 'iezu_tips', label: 'Iežu tips', editable: false },
    { name: 'karsta_zona', label: 'Karsta apgabalu izplatība', editable: false },
    { name: 'nitrat_zona', label: 'Nitrātu jutīgās teritorijas', editable: false },
    { name: 'notece', label: 'Pazemes ūdeņu krājumu papildināšanās', editable: false },
    { name: 'filtracijas_koef', label: 'Filtrācijas koeficients, m/dnn', editable: false },
    { name: 'gradients', label: 'Gradients', editable: false },
    { name: 'porainiba', label: 'Porainība', editable: false },
    { name: 'biezums', label: 'Efektīvais biezums, m', editable: false },
    { name: 'plusmas_virziens', label: 'Plūsmas virziens, grādi', editable: false },
    { name: 'vispariga_piezimes', label: 'Piezīmes', editable: false },
    {
        name: 'zemes_lietojums_detalizeti', label: 'Zemes lietošanas veids', editable: false,
        renderer: (_fieldValue, dataObj) => renderZemesLietojumsTable(dataObj)
    },
    { name: 'dabas_ter', label: 'Īpaši aizsargājamās dabas teritorijas', editable: false }
];

class RiskaNovertejumsBaseinsSnapshot extends Component {
    render() {
        const { novertejums } = this.props;

        if (!novertejums) {
            return <Alert color="info">Nav datu</Alert>;
        }

        if (!this.baseinsSnapshotFormFieldCfgs) {
            this.baseinsSnapshotFormFieldCfgs = getBaseinsSnapshotFormFieldCfgs();
        }

        return (
            <div className="form-container" style={{ maxHeight: 'calc(100vh - 250px)', overflowY: 'auto' }}>
                <FormCard title="Vispārīgais raksturojums" size={12}>
                    <Form
                        editable={false}
                        dataObj={novertejums}
                        formFieldCfgs={this.baseinsSnapshotFormFieldCfgs}
                        metadataFormCfg="riska_novertejumi_view"
                    />
                </FormCard>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    novertejums: (state.riskaNovertejumi || {}).selectedItem
});

export default connect(mapStateToProps)(RiskaNovertejumsBaseinsSnapshot);
